import React, { useState, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import PasswordInput from '../components/PasswordInput';

export default function Register() {
  const [formData, setFormData] = useState({ 
    name: '',
    phone: '',
    email: '', 
    password: '' 
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const phoneInputRef = useRef(null);
  const { register, login } = useAuth(); 
  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, phone: value });
    
    if (phoneInputRef.current) {
      phoneInputRef.current.setCustomValidity('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const phoneInput = phoneInputRef.current;
    const hasNonDigits = /\D/.test(formData.phone);
    //telefon mezőbe csak szám lehet
    if (hasNonDigits) {
      phoneInput.setCustomValidity('A telefonszám mezőbe csak számokat írhatsz be!');
      phoneInput.reportValidity();
      return;
    } else {
      phoneInput.setCustomValidity('');
    }

    setLoading(true);

    try {
      const result = await register(formData);
      
      if (result.success) {
        // Automatikus bejelentkezés regisztráció után
        const loginResult = await login(formData.email, formData.password);
        
        if (loginResult.success) {
          const userRole = loginResult.user?.role;
          if (userRole === 'Rendszergazda') {
            navigate('/rendszergazda-panel');
          } else if (userRole === 'Fodrász') {
            navigate('/fodrasz-panel');
          } else {
            navigate('/foglalas');
          }
        } else {
          navigate('/foglalas');
        }
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Hálózati hiba történt a regisztráció során.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-6 transition-colors">
      <div className="max-w-md w-full bg-transparent rounded-[0.5rem] shadow-none p-5 sm:p-10 border border-gray-300 dark:border-gray-700 transition-colors shadow-2xl p-6">
        <h2 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white mb-2 uppercase tracking-tighter text-center">Regisztráció</h2>

        <p className="text-gray-400 dark:text-gray-500 font-bold text-xs uppercase tracking-widest mb-10 text-center">Hozd létre a profilod</p>

        {error && <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-xl text-[10px] font-black uppercase transition-colors">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="text"
            required
            placeholder="Teljes név"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full p-4 border-2 border-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-colors"
          />
          <input
            ref={phoneInputRef}
            type="text"
            placeholder="Telefonszám (pl. 06301234567)"
            value={formData.phone}
            onChange={handlePhoneChange}
            className="w-full p-4 border-2 border-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-colors"
          />
          <input
            type="email"
            required
            placeholder="Email cím"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full p-4 border-2 border-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-colors"
          />
          <PasswordInput
            required
            placeholder="Jelszó"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            className="w-full p-4 border-2 border-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-xl focus:border-blue-500 dark:focus:border-blue-400 outline-none font-bold transition-colors"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-pink-500 to-orange-500 dark:bg-blue-700 text-white py-5 rounded-xl font-black uppercase tracking-widest shadow-xl  dark:hover:from-pink-700 dark:hover:to-orange-700 transition-all disabled:opacity-50"
          >
            {loading ? 'Folyamatban...' : 'Regisztráció véglegesítése'}
          </button>
        </form>

        <div className="mt-8 text-center border-t border-gray-300 dark:border-gray-700 pt-6 transition-colors">
          <Link to="/bejelentkezes" className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500  text-xs font-black uppercase hover:underline">Már van fiókom →</Link>
        </div>
      </div>
    </div>
  );
}